// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/fonts/Nunito/Nunito.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar {
  height: 40px;
  width: 2px;
  background-color: orange;
}

.specimenInfo {
  font-family: montserrat, sans-serif !important;
}

.labspecimenInfo {
  font-family: Nunito, sans-serif !important;
}

.back_color {
  background-color: #007887;
  color: white;
}

.text-warning {
  color: #f0ad4e !important;
}

.success_border {
  border-radius: 3px;
  border-left: 5px solid green;
  border-bottom: 1px solid green;
  border-top: 1px solid green;
  border-right: 1px solid green;
  font-size: 11px;
  cursor: pointer;
}

.warning_border {
  border-radius: 3px;
  border-left: 5px solid #f0ad4e;
  border-bottom: 1px solid #f0ad4e;
  border-top: 1px solid #f0ad4e;
  border-right: 1px solid #f0ad4e;
  font-size: 11px;
  cursor: pointer;
}

.notes {
  font-size: 11px;
  color: #19727f;
  font-weight: 500;
}

.lables_style {
  font-size: 10px !important;
  color: #001C3B;
  font-weight: 500;
  padding: 3px;
}

.specimentinfo_main {
  overflow-x: hidden;
  height: 68vh;
}

.site_font {
  font-size: 9px !important;
}

.sequence_font {
  font-size: 20px !important;
}

.site_producers_font {
  font-size: 13px !important;
  color: #17a0b4 !important;
}

.gross_description {
  font-size: 11px !important;
}

.micrographs_lable {
  font-weight: 800 !important;
  font-size: 11px !important;
  display: block !important;
  margin-bottom: 3px !important;
}

.pending_procedure {
  font-weight: 800;
  font-size: 11px;
}

.overflowx_casespecimen {
  overflow-x: hidden;
}

.notsendout {
  width: 100%;
  left: 6%;
  position: relative;
}

::ng-deep.sendoutdata {
  overflow-x: hidden !important;
  font-size: 11px !important;
  font-family: montserrat, sans-serif !important;
  height: 14vh !important;
  display: block;
  width: 225px;
}

::ng-deep.sendoutdatalab {
  overflow-x: hidden !important;
  font-size: 11px !important;
  height: 14vh !important;
  display: block;
  width: 225px;
  font-family: Nunito, sans-serif !important;
}

::ng-deep.sendout {
  overflow-x: hidden !important;
  font-size: 11px !important;
  font-family: montserrat, sans-serif !important;
  height: 16vh !important;
  display: block;
  width: 225px;
}

::ng-deep.sendoutlab {
  overflow-x: hidden !important;
  font-size: 11px !important;
  height: 16vh !important;
  display: block;
  width: 225px;
  font-family: Nunito, sans-serif !important;
}

.timezone-notice {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 8px 80px;
  height: 40px;
  z-index: 1000;
}
.timezone-notice .timezone-notice-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
  height: 100%;
  padding-left: 15px;
}
.timezone-notice .timezone-notice-content i {
  margin-right: 8px;
  color: #17a2b8;
  font-size: 14px;
}
.timezone-notice .timezone-notice-content span {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/casespecimen/casespecimen.component.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,UAAA;EACA,wBAAA;AAAF;;AAGA;EACE,8CAAA;AAAF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,4BAAA;EACE,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;AACJ;;AACA;EACE,kBAAA;EACA,8BAAA;EACE,gCAAA;EACA,6BAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;AAEJ;;AAEA;EACE,eAAA;EAAgB,cAAA;EAAe,gBAAA;AAGjC;;AAAA;EACE,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAGF;;AACA;EACA,kBAAA;EACA,YAAA;AAEA;;AACA;EACE,yBAAA;AAEF;;AAAA;EACE,0BAAA;AAGF;;AAAA;EACE,0BAAA;EACU,yBAAA;AAGZ;;AAAA;EACE,0BAAA;AAGF;;AAAA;EACE,2BAAA;EAA4B,0BAAA;EAA2B,yBAAA;EAA0B,6BAAA;AAMnF;;AAHA;EACE,gBAAA;EAAiB,eAAA;AAOnB;;AAHA;EACE,kBAAA;AAMF;;AAHA;EACI,WAAA;EACA,QAAA;EACA,kBAAA;AAMJ;;AAJA;EACE,6BAAA;EACA,0BAAA;EACA,8CAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AAOF;;AALA;EACE,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,0CAAA;AAQF;;AANA;EACE,6BAAA;EACA,0BAAA;EACA,8CAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AASF;;AAPA;EACE,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,0CAAA;AAUF;;AAPA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAUF;AARE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAUJ;AARI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAUN;AAPI;EACE,gBAAA;AASN","sourcesContent":["@import 'src/assets/fonts/Nunito/Nunito.css';\r\n\r\n.bar{\r\n  height: 40px;\r\n  width: 2px;\r\n  background-color: orange;\r\n}\r\n\r\n.specimenInfo{\r\n  font-family: montserrat, sans-serif !important;\r\n}\r\n.labspecimenInfo{\r\n  font-family: Nunito, sans-serif !important;\r\n}\r\n\r\n.back_color{\r\n  background-color: #007887;\r\n  color: white;\r\n}\r\n\r\n.text-warning {\r\n  color: #f0ad4e !important;\r\n}\r\n\r\n.success_border{\r\n  border-radius: 3px;\r\n  border-left: 5px solid green;\r\n    border-bottom: 1px solid green;\r\n    border-top: 1px solid green;\r\n    border-right: 1px solid green;\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n}\r\n.warning_border{\r\n  border-radius: 3px;\r\n  border-left: 5px solid #f0ad4e;\r\n    border-bottom: 1px solid #f0ad4e;\r\n    border-top: 1px solid #f0ad4e;\r\n    border-right: 1px solid #f0ad4e;\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.notes{\r\n  font-size: 11px;color: #19727f;font-weight: 500;\r\n}\r\n\r\n.lables_style{\r\n  font-size: 10px !important;\r\n  color: #001C3B;\r\n  font-weight: 500;\r\n  padding: 3px;\r\n}\r\n\r\n\r\n.specimentinfo_main{\r\noverflow-x: hidden;\r\nheight: 68vh;\r\n}\r\n\r\n.site_font{\r\n  font-size: 9px !important;\r\n}\r\n.sequence_font{\r\n  font-size: 20px !important;\r\n}\r\n\r\n.site_producers_font{\r\n  font-size: 13px !important;\r\n            color: #17a0b4 !important;\r\n}\r\n\r\n.gross_description{\r\n  font-size: 11px !important;\r\n}\r\n\r\n.micrographs_lable{\r\n  font-weight: 800 !important;font-size: 11px !important;display: block !important;margin-bottom: 3px !important;\r\n}\r\n\r\n.pending_procedure{\r\n  font-weight: 800;font-size: 11px;\r\n}\r\n\r\n\r\n.overflowx_casespecimen{\r\n  overflow-x: hidden;\r\n}\r\n\r\n.notsendout{\r\n    width: 100%;\r\n    left: 6%;\r\n    position: relative;\r\n}\r\n::ng-deep.sendoutdata {\r\n  overflow-x: hidden !important;\r\n  font-size: 11px !important;\r\n  font-family: montserrat, sans-serif !important;\r\n  height: 14vh !important;\r\n  display: block;\r\n  width: 225px;\r\n}\r\n::ng-deep.sendoutdatalab {\r\n  overflow-x: hidden !important;\r\n  font-size: 11px !important;\r\n  height: 14vh !important;\r\n  display: block;\r\n  width: 225px;\r\n  font-family: Nunito, sans-serif !important;\r\n}\r\n::ng-deep.sendout {\r\n  overflow-x: hidden !important;\r\n  font-size: 11px !important;\r\n  font-family: montserrat, sans-serif !important;\r\n  height: 16vh !important;\r\n  display: block;\r\n  width: 225px;\r\n}\r\n::ng-deep.sendoutlab {\r\n  overflow-x: hidden !important;\r\n  font-size: 11px !important;\r\n  height: 16vh !important;\r\n  display: block;\r\n  width: 225px;\r\n  font-family: Nunito, sans-serif !important;\r\n}\r\n// Timezone Notice Styles - Fixed at bottom of screen\r\n.timezone-notice {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background-color: #f8f9fa;\r\n  border-top: 1px solid #dee2e6;\r\n  padding: 8px 80px;\r\n  height: 40px;\r\n  z-index: 1000;\r\n  \r\n  .timezone-notice-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    font-size: 12px;\r\n    color: #6c757d;\r\n    font-style: italic;\r\n    height: 100%;\r\n    padding-left: 15px;\r\n    \r\n    i {\r\n      margin-right: 8px;\r\n      color: #17a2b8;\r\n      font-size: 14px;\r\n    }\r\n    \r\n    span {\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
